// data/mockData.ts
import { User, Project, ProjectStatus } from '../types';

export const mockUsers: User[] = [
  {
    id: 1,
    name: 'John Doe',
    role: 'ADMIN',
    permissions: ['CREATE', 'EDIT', 'DELETE', 'APPROVE'],
  },
  {
    id: 2,
    name: 'Jane Smith',
    role: 'MANAGER',
    permissions: ['CREATE', 'EDIT', 'APPROVE'],
  },
  {
    id: 3,
    name: 'Bob Wilson',
    role: 'USER',
    permissions: ['CREATE', 'EDIT'],
  },
];

export const mockProjects: Project[] = [
  {
    id: 'PRJ-2024-001',
    name: 'City Center Renovation',
    client: 'Metro Development Corp',
    location: 'Downtown Area',
    status: 'APPROVED',
    description: 'Major renovation project for the city center area',
    createdBy: 1,
    createdByUser: 'John Doe',
    createdAt: '2024-02-10T10:30:00Z',
    lastModified: '2024-02-11T14:20:00Z',
    lastStatusChange: '2024-02-11T14:20:00Z',
    attachments: [
      {
        id: 1,
        name: 'blueprint.dwg',
        type: 'DWG',
        size: 15000000,
        uploadedAt: '2024-02-10T10:35:00Z',
      },
      {
        id: 2,
        name: 'site-photo.jpg',
        type: 'JPEG',
        size: 5000000,
        uploadedAt: '2024-02-10T10:36:00Z',
      },
    ],
  },
  {
    id: 'PRJ-2024-002',
    name: 'Park Restoration',
    client: 'City Council',
    location: 'West Park',
    status: 'DRAFT',
    description: 'Restoration of the west park facilities',
    createdBy: 2,
    createdByUser: 'Jane Smith',
    createdAt: '2024-02-11T09:15:00Z',
    lastModified: '2024-02-11T09:15:00Z',
    lastStatusChange: '2024-02-11T09:15:00Z',
    attachments: [],
  },
];

export const STATUS_CONFIG = {
  Draft: {
    order: 0,
    label: 'Draft',
    color: 'bg-gray-200',
    description: 'Initial project creation',
  },
  Submitted: {
    order: 1,
    label: 'Submitted',
    color: 'bg-blue-200',
    description: 'Awaiting review',
  },
  Approved: {
    order: 2,
    label: 'Approved',
    color: 'bg-green-200',
    description: 'Project approved',
  },
  Archived: {
    order: 3,
    label: 'Archived',
    color: 'bg-yellow-200',
    description: 'Project completed',
  },
};
